import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import jsPDF from "jspdf";
import tmplLogo from "../images/tmplLogo.png";

const PaymentReceipt = () => {
   const location = useLocation();
  const userid = location.state?.userid;
  const paymentId = location.state?.paymentId;
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const generateAndDownloadPDF = async () => {
      try {
        setLoading(true);
        // Fetch payment and user details
        const [paymentResponse, userResponse] = await Promise.all([
          axios.get(`/api/user/userpayment/getById/${paymentId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`/api/employeedetails/userid=${userid}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
        ]);

        const paymentDetails = paymentResponse.data;
        const userDetails = userResponse.data;

        // Total amount
        const totalAmount = parseFloat(paymentDetails.paymentAmount);
        // const platformFeeRate = 0.03;
        // const platformGstRate = 0.18;

        const platFormFee = parseFloat(paymentDetails.platformFee);

        // Calculate Actual Price
        const actualPrice = totalAmount - platFormFee;

        // Calculate Platform Fee and Platform Fee GST
        // const platformFee = actualPrice * platformFeeRate;
        // const platformFeeGst = platformFee * platformGstRate;

        // Calculate other amounts (CGST and SGST are zero in this case)
        const cgst = 0;
        const sgst = 0;

        // Create PDF document
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();

        // Define image properties
        const imageWidth = 40;
        const imageHeight = 15;
        const margin = 10;

        // Calculate x-coordinate for the image
        const x = pageWidth - imageWidth - margin;

        // Add the image to the right end of the receipt
        doc.addImage(tmplLogo, 'PNG', x, 10, imageWidth, imageHeight);

        // Add title
        doc.setFontSize(16);
        doc.text("RECEIPT", 10, 20);

        // Add company details
        doc.setFontSize(12);
        doc.text("Timespan Pvt Ltd.", 10, 30);
        doc.text("Bangalore, Karnataka", 10, 40);
        doc.text("PIN: 123456", 10, 50);
        doc.text("GSTIN: 29AAJCC7045D1ZM", 10, 60);

        // Add Bill To section
        doc.text("Bill To", 10, 80);
        doc.text(userDetails.email, 10, 90);
        doc.text(userDetails.address, 10, 100);
        doc.text(`PAN: ${userDetails.pan}`, 10, 110);

        // Add Reference Number
        doc.text("Reference Number:", 10, 130);
        doc.text(paymentDetails.razorpay_payment_id, 60, 130);

        // Add Total Amount section
        doc.setFontSize(14);
        doc.text("Total Amount", 10, 150);
        doc.text(`${totalAmount.toFixed(2)} Rs`, pageWidth - 30, 150, { align: "right" });

        doc.setLineWidth(1);
        doc.line(10, 160, pageWidth - 10, 160);

        // Add Details Section
        doc.setFontSize(12);
        doc.text(`Amount: ${actualPrice.toFixed(2)}`, 10, 180);
        doc.text(`CGST: ${cgst.toFixed(2)}`, 10, 190);
        doc.text(`SGST: ${sgst.toFixed(2)}`, 10, 200);
        doc.text(`Platform Fee: ${platFormFee.toFixed(2)}`, 10, 210);
        doc.text(`Total Amount: ${totalAmount.toFixed(2)} Rs`, 10, 230);

        // Save the PDF
        doc.save("receipt.pdf");
        
        // toast.success("Receipt downloaded successfully!");
        setLoading(false);
        // Navigate back after download
        setTimeout(() => {
          navigate(-1);
        }, 1000);

      } catch (error) {
        setLoading(false);
        console.error("Error generating PDF: ", error);
        toast.error("Failed to generate receipt.");
        
        // Navigate back even on error
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      }
    };

    if (userid && paymentId) {
      generateAndDownloadPDF();
    }
  }, [userid, paymentId, token, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
         {loading && <div className="loading"></div>}
      {/* <p className="mt-3">Generating receipt...</p> */}
    </div>
  );
};

export default PaymentReceipt;